import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, ArrowRight } from "lucide-react";
import api from "@/lib/api";

// Compact dashboard module card for APQP. Clicking it opens the /apqp list page.
export default function ApqpDashboardCard() {
  const [stats, setStats] = useState({ total: 0, wip: 0, complete: 0 });

  useEffect(() => {
    api.get("/apqp").then((r) => {
      const list = r.data || [];
      setStats({
        total: list.length,
        wip: list.filter((p) => p.status !== "Complete").length,
        complete: list.filter((p) => p.status === "Complete").length,
      });
    }).catch(() => {});
  }, []);

  return (
    <Link to="/apqp" data-testid="apqp-dashboard-card"
      className="block bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700 rounded-xl p-4 mb-4 hover:border-orange-500/60 hover:shadow-lg transition-all group">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-lg bg-orange-500/15 flex items-center justify-center">
            <ClipboardList size={22} className="text-orange-400" />
          </div>
          <div>
            <h2 className="text-base font-semibold text-white">APQP Projects</h2>
            <p className="text-xs text-slate-400">Auto-created from Won costings · phase-grouped plans</p>
          </div>
        </div>
        <div className="flex items-center gap-6">
          <div className="text-center"><div className="text-2xl font-bold text-white">{stats.total}</div><div className="text-[10px] uppercase tracking-wider text-slate-500">Total</div></div>
          <div className="text-center"><div className="text-2xl font-bold text-amber-400">{stats.wip}</div><div className="text-[10px] uppercase tracking-wider text-slate-500">WIP</div></div>
          <div className="text-center"><div className="text-2xl font-bold text-emerald-400">{stats.complete}</div><div className="text-[10px] uppercase tracking-wider text-slate-500">Complete</div></div>
          <ArrowRight size={18} className="text-slate-500 group-hover:text-orange-400 transition-colors" />
        </div>
      </div>
    </Link>
  );
}
